import React from "react";
import { graphql } from "gatsby";
import Section from "../components/section";
import GlobalStyle from "../styles/globalStyles";

const IndexPage = ({ data }) => {
  return (
    <>
      <GlobalStyle />
      <Section
        datoContentData={data.allDatoCmsBespokeStory.edges[0].node.content}
        heroImage={data.allDatoCmsBespokeStory.edges[0].node.heroImage}
      />
    </>
  );
};

export default IndexPage;

export const query = graphql`
  query StoryQuery {
    allDatoCmsBespokeStory(
      filter: { id: { eq: "DatoCmsBespokeStory-PihslcFWQReDKaFlLtiD5g-en" } }
    ) {
      edges {
        node {
          id
          title
          heroImage {
            fluid {
              src
              srcSet
              aspectRatio
            }
          }
          content {
            ...DatoAgeGateFragment
            ...DatoArticleAggregatorFragment
            ...DatoCreditFragment
            ...DatoCtaFragment
            ...DatoCustomMarkupFragment
            ...DatoGalleryFragment
            ...DatoHeadlineFragment
            ...DatoHeroFragment
            ...DatoImageFragment
            ...DatoImageTextFragment
            ...DatoInterviewFragment
            ...DatoLayoutDividerFragment
            ...DatoLoaderFragment
            ...DatoMarqueeFragment
            ...DatoParagraphFragment
            ...DatoProgressBarFragment
            ...DatoQuoteFragment
            ...DatoSeparatorFragment
            ...DatoShoppingCarouselFragment
            ...DatoSvgFragment
            ...DatoVideoFragment
            ...DatoKeyValuePairFragment
          }
        }
      }
    }
  }
`;
